import { Marker, Polygon } from "react-leaflet";
import L from "leaflet";
import LeafletMap, { FitBounds } from "@/components/map/LeafletMap";

const pin = L.divIcon({
  className: "",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  html: `<div style="width:24px;height:24px;border-radius:9999px;background:#10B981;border:3px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.35);cursor:grab"></div>`,
});

export default function LocationPicker({ lat, lng, onChange, height = 300, defaultCenter = [41.75, -71.3], defaultZoom = 11, zones = [], boundary = [] }) {
  const has = lat != null && lng != null && !isNaN(Number(lat)) && !isNaN(Number(lng));
  const la = has ? Number(lat) : defaultCenter[0];
  const ln = has ? Number(lng) : defaultCenter[1];
  const allPts = [...zones.flatMap((z) => z || []), ...(boundary || [])];
  return (
    <div data-testid="shop-location-picker">
      <LeafletMap height={height} center={[la, ln]} zoom={has ? 14 : defaultZoom} onClick={(a, b) => onChange(a, b)}>
        {boundary?.length >= 3 && <Polygon positions={boundary} pathOptions={{ color: "#64748B", weight: 2, fillOpacity: 0.04, dashArray: "6" }} />}
        {zones.map((z, i) => (z?.length >= 3) && <Polygon key={i} positions={z} pathOptions={{ color: "#EF4444", fillColor: "#FACC15", weight: 2, fillOpacity: 0.2 }} />)}
        {has && (
          <Marker
            position={[la, ln]}
            draggable
            icon={pin}
            eventHandlers={{ dragend: (e) => { const p = e.target.getLatLng(); onChange(p.lat, p.lng); } }}
          />
        )}
        {has
          ? <FitBounds bounds={[[la - 0.003, ln - 0.003], [la + 0.003, ln + 0.003]]} nonce={`${la},${ln}`} />
          : (allPts.length >= 2 && <FitBounds bounds={allPts} nonce={`z${allPts.length}`} />)}
      </LeafletMap>
    </div>
  );
}
